<template>
  <add-new-site default-message="Let's add your new site... Only 2 steps!" />
</template>

<script>
import AddNewSite from '@/views/components/dashboard/AddNewSite';

export default {
  name: 'AddASite',
  components: {
    AddNewSite,
  },
};
</script>

<style lang="scss" scoped=""></style>
